import type { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import {
  faCcVisa,
  faPaypal,
  faStripeS,
} from '@fortawesome/free-brands-svg-icons'
import {
  faAddressBook,
  faBarcode,
  faBolt,
  faBook,
  faBoxesStacked,
  faBoxOpen,
  faBullhorn,
  faCalendar,
  faCalendarCheck,
  faCalendarDay,
  faCalendarDays,
  faCalendarXmark,
  faCameraRetro,
  faCartShopping,
  faCashRegister,
  faChartLine,
  faChartPie,
  faClipboardCheck,
  faCreditCard,
  faCubes,
  faEnvelope,
  faEnvelopeOpenText,
  faFileInvoiceDollar,
  faFlask,
  faFolderOpen,
  faGear,
  faGlobe,
  faHandshake,
  faHeadset,
  faIdCardClip,
  faImage,
  faImages,
  faInbox,
  faLayerGroup,
  faLocationDot,
  faLock,
  faMagnifyingGlass,
  faMapLocationDot,
  faMobileScreen,
  faMoneyBillTransfer,
  faNewspaper,
  faPercent,
  faPhotoFilm,
  faPuzzlePiece,
  faQrcode,
  faReceipt,
  faRobot,
  faShieldHalved,
  faShop,
  faSliders,
  faStar,
  faStore,
  faTags,
  faTicket,
  faTruckFast,
  faUserCheck,
  faUserClock,
  faUserTag,
  faUtensils,
  faWarehouse,
} from '@fortawesome/free-solid-svg-icons'

/**
 * Icons a plugin may reference by name — for itself (`icon`), its navigation
 * items, dashboard widgets and feature flags. Names follow Font Awesome's
 * kebab-case names; anything unknown falls back to the puzzle piece, so a
 * manifest can never inject markup or load assets.
 */
export const PLUGIN_ICONS: Record<string, IconDefinition> = {
  // content & media
  images: faImages,
  image: faImage,
  'photo-film': faPhotoFilm,
  'camera-retro': faCameraRetro,
  newspaper: faNewspaper,
  book: faBook,
  calendar: faCalendar,
  globe: faGlobe,
  'magnifying-glass': faMagnifyingGlass,
  // CRM
  'address-book': faAddressBook,
  'folder-open': faFolderOpen,
  'id-card-clip': faIdCardClip,
  'user-tag': faUserTag,
  handshake: faHandshake,
  headset: faHeadset,
  envelope: faEnvelope,
  'envelope-open-text': faEnvelopeOpenText,
  bullhorn: faBullhorn,
  // catalog & inventory
  tags: faTags,
  'box-open': faBoxOpen,
  cubes: faCubes,
  barcode: faBarcode,
  warehouse: faWarehouse,
  'boxes-stacked': faBoxesStacked,
  'clipboard-check': faClipboardCheck,
  'layer-group': faLayerGroup,
  lock: faLock,
  // commerce
  store: faStore,
  shop: faShop,
  'cart-shopping': faCartShopping,
  receipt: faReceipt,
  'cash-register': faCashRegister,
  'credit-card': faCreditCard,
  'file-invoice-dollar': faFileInvoiceDollar,
  'money-bill-transfer': faMoneyBillTransfer,
  utensils: faUtensils,
  'truck-fast': faTruckFast,
  'map-location-dot': faMapLocationDot,
  percent: faPercent,
  ticket: faTicket,
  // payment brands (monochrome, like every icon in the GXLabs system)
  stripe: faStripeS,
  paypal: faPaypal,
  'cc-visa': faCcVisa,
  // general
  'chart-line': faChartLine,
  'chart-pie': faChartPie,
  bolt: faBolt,
  flask: faFlask,
  // Appointment Booking
  'calendar-check': faCalendarCheck,
  'calendar-day': faCalendarDay,
  'calendar-days': faCalendarDays,
  'calendar-xmark': faCalendarXmark,
  sliders: faSliders,
  'location-dot': faLocationDot,
  'user-clock': faUserClock,
  'user-check': faUserCheck,
  robot: faRobot,
  'shield-halved': faShieldHalved,
  gear: faGear,
  star: faStar,
  // Mobile App
  'mobile-screen': faMobileScreen,
  qrcode: faQrcode,
  inbox: faInbox,
}

export const FALLBACK_PLUGIN_ICON = faPuzzlePiece

export function pluginIcon(name?: string | null): IconDefinition {
  return (name && PLUGIN_ICONS[name]) || FALLBACK_PLUGIN_ICON
}
